import { Alert } from '@mui/material'

const DoseCalibratorStatus = () => {
  return <Alert severity="error">{'L\'activimètre est indisponible.'}</Alert>
}

export default DoseCalibratorStatus
